import React from 'react';
import { EdgeProps, getStraightPath } from 'reactflow';
import { Box, Typography } from '@mui/material';
import { IndicacaoEdgeData, getCoresNivel } from '../../../utils/indicacaoFlowUtils';

const IndicacaoEdge: React.FC<EdgeProps<IndicacaoEdgeData>> = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
}) => {
  const [edgePath, labelX, labelY] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  const nivel = data?.nivel || 1;
  const cores = getCoresNivel(nivel);

  // Configurações da linha baseadas no nível
  const getEdgeStyles = () => {
    return {
      strokeWidth: 2,
      stroke: cores.border,
      strokeDasharray: nivel > 1 ? '5,5' : 'none',
      opacity: 0.8,
      filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.1))',
    };
  };

  // Marcador da seta
  const markerId = `arrow-${nivel}`;

  return (
    <>
      {/* Definição do marcador da seta */}
      <defs>
        <marker
          id={markerId}
          markerWidth="10"
          markerHeight="10"
          refX="9"
          refY="3"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <polygon
            points="0,0 0,6 9,3"
            fill={cores.border}
            stroke="none"
          />
        </marker>
      </defs>

      {/* Linha da conexão */}
      <path
        d={edgePath}
        style={getEdgeStyles()}
        markerEnd={`url(#${markerId})`}
      />
    </>
  );
};

export default IndicacaoEdge; 